import { combineReducers } from 'redux';

import alternateEmailReducer from '../components/CMS/Subscriber/AccountSettings/AlternateEmail/reducers';
import { cartReducer } from '../components/CMS/Guest/Cart/reducers';
import confirmAlternateEmailReducer from '../components/CMS/Guest/ConfirmAlternateEmail/reducers';
import courseReducer from '../components/CMS/Subscriber/MyLeaning/Course/reducer';
import { licenseeReducer, licenseeIdReducer, currentLicenseeReducer, countriesReducer } from '../components/CMS/Subscriber/Licensees/reducer';
import productReducer from '../components/CMS/Subscriber/Products/reducer';
import profileUserReducer from '../components/CMS/Subscriber/AccountSettings/reducer';
import purchaseReducer from '../components/CMS/Subscriber/Purchases/reducers';
import setUserTests from '../components/CMS/Subscriber/MyCECertificates/reducers';
import takeSurveyReducer from '../components/CMS/Subscriber/TakeSurvey/reducers';
import takeTestReducer from '../components/CMS/Subscriber/TakeTest/reducers';
import userDesignationReducer from '../components/CMS/Subscriber/MyDesignation/reducer';
import videoReducer from '../components/General/Media/Video/reducer';
import organizationMembersReducer from '../components/CMS/Organizations/OrganizationMembers/reducer';
import managedOrganizationsReducer from '../components/CMS/Organizations/ManagedOrganizations/reducer';
import {
     organizationSeatsFilterReducer,
     listOrganizationSeatsReducer,
     listOrganizationBundleSeatsReducer,
} from '../components/CMS/Organizations/ManageSeats/OrganizationSeats/reducer';
import organizationCoursesReducer from '../components/CMS/Organizations/OrganizationCourses/reducer';
import organizationOrdersReducer from '../components/CMS/Organizations/Purchases/Orders/reducer';

import {
     sellingGroupsReducer,
     sellingGroupCategoriesReducer,
     sellingGroupFilterOptionReducer,
     sellingGroupFilterSelectedReducer,
     timezoneReducer,
     filterCategoryReducer,
     attachedEvents,
} from '../components/CMS/Guest/SellingGroups/reducers';
import {
     countryCodeReducer,
     listActiveSeatByUserReducer,
     productTypeReducer,
     seatByTokenReducer,
     userLessonReducer,
     userLessonsReducer,
     userProfessionalFieldLicenseReducer,
     userProfessionalFieldReducer,
     userReducer,
} from '../components/CMS/Subscriber/GlobalStateReduces';
import seatReducer from '../components/CMS/Subscriber/Seats/reducer';
import ordersUserReducer, { awaitingOrderItemsReducer } from '../components/CMS/Guest/Checkout/reducer';
import organizationTrainingGroupReducer from '../components/CMS/Organizations/TrainingGroups/reducers';
import organizationReducer from '../components/CMS/Organizations/Purchases/PaymentMethod/reducer';
import userNotificationsReducer from '../components/CMS/Subscriber/GlobalStates/Notification/reducers';
import { checkoutCeProductRPT } from '../components/CMS/Guest/Checkout/reducer';
import contentManagementReducer from '../containers/guest/reducer';
import currentCountryReducer from '../components/CMS/Subscriber/GlobalStates/CurrentCountry/reducers';
import currentLocationReducer from '../components/CMS/Subscriber/GlobalStates/CurrentLocation/reducers';
import { seatAddressReducer } from '../components/CMS/Subscriber/GlobalStates/Seat/reducers';

const subscriberReducer = combineReducers({
     alternateEmail: confirmAlternateEmailReducer,
     alternateEmails: alternateEmailReducer,
     attachedEvents,
     awaitingOrderItems: awaitingOrderItemsReducer,
     cart: cartReducer,
     checkoutCeProductRPT: checkoutCeProductRPT,
     countries: countriesReducer,
     countryCode: countryCodeReducer,
     currentCountry: currentCountryReducer,
     currentLocation: currentLocationReducer,
     courses: courseReducer,
     currentLicensee: currentLicenseeReducer,
     filterCategory: filterCategoryReducer,
     lessonVideoRef: videoReducer,
     licenseeId: licenseeIdReducer,
     licensees: licenseeReducer,
     listActiveSeatByUser: listActiveSeatByUserReducer,
     managedOrganizations: managedOrganizationsReducer,
     notifications: userNotificationsReducer,
     ordersUser: ordersUserReducer,
     organization: organizationReducer,
     organizationCourses: organizationCoursesReducer,
     organizationMembers: organizationMembersReducer,
     organizationOrders: organizationOrdersReducer,
     organizationSeatsFilter: organizationSeatsFilterReducer,
     listOrganizationSeats: listOrganizationSeatsReducer,
     listOrganizationBundleSeats: listOrganizationBundleSeatsReducer,
     organizationTrainingGroups: organizationTrainingGroupReducer,
     products: productReducer,
     productTypes: productTypeReducer,
     profileUser: profileUserReducer,
     purchase: purchaseReducer,
     seatByToken: seatByTokenReducer,
     seatAddress: seatAddressReducer,
     sellingGroupCategories: sellingGroupCategoriesReducer,
     sellingGroups: sellingGroupsReducer,
     sellingGroupFilterOptions: sellingGroupFilterOptionReducer,
     sellingGroupFilterSelected: sellingGroupFilterSelectedReducer,
     takeSurvey: takeSurveyReducer,
     takeTest: takeTestReducer,
     timezoneSelected: timezoneReducer,
     user: userReducer,
     userDesignation: userDesignationReducer,
     userLesson: userLessonReducer,
     userLessons: userLessonsReducer,
     userProfessionalField: userProfessionalFieldReducer,
     userProfessionalFieldLicense: userProfessionalFieldLicenseReducer,
     userSeats: seatReducer,
     userTests: setUserTests,
     contentManagements: contentManagementReducer,
});

export default subscriberReducer;
